<template>
  <v-form ref="form">
    <v-container grid-list-md>
      <v-layout v-if="!ui.loading">
        <v-flex xs12>
          <v-toolbar color="pink" dark>
            <v-icon>confirmation_number</v-icon>
            <v-toolbar-title>Find Registration Number</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs6>
                  <v-text-field v-model="aadhar" label="Player Aadhar Number" :rules="ui.required"></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-dialog ref="dateDialog" v-model="ui.dateOpen" :return-value.sync="dob" persistent lazy full-width width="290px">
                    <template v-slot:activator="{ on }">
                      <v-text-field v-model="formattedDate" label="Date of birth" readonly v-on="on" :rules="ui.required"></v-text-field>
                    </template>
                    <v-date-picker v-model="dob" scrollable :max="ui.maxDate">
                      <v-spacer></v-spacer>
                      <v-btn flat color="primary" @click="ui.dateOpen = false">Cancel</v-btn>
                      <v-btn flat color="primary" @click="$refs.dateDialog.save(dob)">OK</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-flex>
                <v-flex xs12>
                  <div>
                    <v-chip v-if="!!profile" color="green" text-color="white"
                      >Name:&nbsp;<span class="text-success">{{ profile.name }}</span></v-chip
                    >
                    <v-chip v-if="!!profile" color="green" text-color="white"
                      >Register Number:&nbsp;<span class="text-success">{{ profile.registerNumber.prefix }}{{ profile.registerNumber.number }}</span></v-chip
                    >
                  </div>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" :loading="ui.loading" @click="find">Find Register Number</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout v-if="ui.loading">
        <v-flex>
          <v-card>
            <div class="text-xs-center pa-3">
              <v-progress-circular indeterminate color="green"></v-progress-circular>
            </div>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <v-snackbar v-model="ui.snackbar" :color="ui.snackbarMode" :timeout="5000">
      <span>{{ ui.feedback }}</span>
      <v-btn dark flat @click="ui.snackbar = false">Close</v-btn>
    </v-snackbar>
  </v-form>
</template>

<script>
import moment from "moment";

export default {
  data: function() {
    return {
      aadhar: "",
      dob: moment()
        .subtract("years", 5)
        .toISOString()
        .split("T")[0],
      profile: null,
      ui: {
        loading: false,
        maxDate: moment()
          .subtract("years", 5)
          .toISOString(),
        valid: null,
        dateOpen: false,
        snackbar: false,
        feedback: "",
        snackbarMode: "success",
        showConfirm: false,
        isDirty: false,
        required: [
          function(x) {
            return x ? true : "This field is required";
          },
        ],
      },
    };
  },
  computed: {
    formattedDate: function() {
      return this.dob ? moment(this.dob).format("DD-MMM-YYYY") : "";
    },
    defaultMonth: function() {
      var date = this.dob || this.ui.maxDate;
      return moment(date).format("YYYY-M");
    },
  },
  methods: {
    find: async function() {
      if (!this.$refs.form.validate()) return;
      this.profile = null;
      var endpoint = this.$api("players/public-search");
      var profile = { aadhar: this.aadhar, dateofbirth: this.formattedDate };
      try {
        var result = await endpoint.post(profile);
        this.profile = result;
      } catch (error) {
        console.log(error);
        if (error.status == 404) {
          this.showsnackBar("No player found with given information.", "error");
        } else if (error.status == 429) {
          this.showsnackBar("Too many requests. Try again after 5 seconds.", "warning");
        }
      }
    },
    showsnackBar: function(msg, mode) {
      this.ui.feedback = msg;
      this.ui.snackbar = true;
      this.ui.snackbarMode = mode || "info";
    },
  },
};
</script>

<style></style>
